import { useEffect, useState } from 'react';

/** Lo que llega por el canal en vivo: solo qué cambió (nunca datos personales). */
export interface LiveEvent {
  type: 'notification' | 'changed';
  kind: string;
  churchId: string | null;
}

type Listener = (e: LiveEvent) => void;
const listeners = new Set<Listener>();
let source: EventSource | null = null;

/** Abre el canal en vivo (una sola conexión por pestaña). Se cierra al salir de la sesión. */
export function startLive(): () => void {
  if (typeof EventSource === 'undefined' || source) return stopLive;
  source = new EventSource('/api/notifications/stream', { withCredentials: true });
  source.onmessage = (m) => {
    try {
      const e = JSON.parse(m.data) as LiveEvent;
      listeners.forEach((l) => l(e));
    } catch {
      // mensaje desconocido: se ignora
    }
  };
  return stopLive;
}

export function stopLive(): void {
  source?.close();
  source = null;
}

/** Escuchar los avisos en vivo. */
export function onLive(listener: Listener): () => void {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

/** Un número que cambia con cada aviso en vivo (para volver a cargar datos sin recargar la página). */
export function useLiveVersion(filter: (e: LiveEvent) => boolean = () => true): number {
  const [v, setV] = useState(0);
  useEffect(() => onLive((e) => filter(e) && setV((x) => x + 1)), []); // eslint-disable-line react-hooks/exhaustive-deps
  return v;
}

/** Para pruebas: simula un aviso en vivo. */
export function emitLive(e: LiveEvent): void {
  listeners.forEach((l) => l(e));
}
